import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard, CalendarDays, School, Users, Settings, LogOut, ClipboardList, Bell, Boxes, History,
} from "lucide-react";
import { Toaster } from "./ui/sonner";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin"] },
  { to: "/workshops", label: "Workshopy", icon: ClipboardList, roles: ["admin", "user"] },
  { to: "/schools", label: "Školy", icon: School, roles: ["admin", "user"] },
  { to: "/lectors", label: "Lektoři", icon: Users, roles: ["admin", "user"] },
  { to: "/calendar", label: "Kalendář", icon: CalendarDays, roles: ["admin", "user"] },
  { to: "/workshop-types", label: "Typy workshopů", icon: Boxes, roles: ["user"] },
  { to: "/notifications", label: "Notifikace", icon: Bell, roles: ["admin", "user"] },
  { to: "/audit", label: "Evidence akcí", icon: History, roles: ["admin"] },
  { to: "/settings", label: "Nastavení", icon: Settings, roles: ["admin"] },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = NAV.filter((n) => n.roles.includes(user?.role));

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-60 shrink-0 border-r border-border flex flex-col fixed h-screen bg-background" data-testid="sidebar">
        <div className="px-5 h-16 flex items-center border-b border-border">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-md bg-primary text-primary-foreground grid place-items-center font-heading font-bold text-sm">L</div>
            <span className="font-heading font-semibold text-[15px] tracking-tight">Lucka</span>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.slice(1)}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-secondary text-foreground font-medium"
                    : "text-muted-foreground hover:bg-secondary/60 hover:text-foreground"
                }`
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 mb-1">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-xs text-muted-foreground capitalize">{user?.role}</div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-muted-foreground hover:bg-secondary/60 hover:text-foreground w-full transition-colors"
          >
            <LogOut className="h-4 w-4" /> Odhlásit se
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-w-0">
        <Outlet />
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
